import { createElement, memo, useContext } from '@max/max';
import View from '@hfe/max-view';
import ScrollView from '@hfe/max-scrollview';
import Sensor from '@max/mbc-sensor';
import OneColCoupon from '../one-col-coupon';
import TwoColCoupon from '../two-col-coupon';
import MoreColCoupon from '../more-col-coupon';
import { lxBidConfig, lxCouponStatusReportMap } from '../../lib/constant';
import './index.scss';
import '../../common.scss';
const CouponList = (props) => {
    var _a, _b;
    const ctx = useContext(global._EngineGlobalContext);
    const { formatCouponConfigRes, isShowContainer, amountColor, couponList = [], currentTimeMillis, toastConfig, updateCouponList, setCurrentTimeMillis, location, bizLine, hotelchannel, enableHorizontalScroll } = props || {};
    const { _LXReport } = ctx;
    const couponAppear = (couponData) => {
        if (!couponData)
            return;
        const { couponGroupId, status, campaignKey } = couponData || {};
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(lxBidConfig.couponMV, {
            valLab: {
                god_campaign_key: campaignKey,
                god_coupon_id: couponGroupId || -999,
                coupon_status: status ? lxCouponStatusReportMap[status] : '',
                custom: {
                    hotel_channel: hotelchannel,
                    click_biz_line: bizLine
                }
            }
        });
    };
    return <>
      <Sensor x-if={couponList.length === 1} once={true} onAppear={() => couponAppear(couponList === null || couponList === void 0 ? void 0 : couponList[0])}>
        <View style={{
            width: '702rpx'
        }} className="row-center">
          <OneColCoupon isShowContainer={isShowContainer} currentTimeMillis={currentTimeMillis} couponData={couponList === null || couponList === void 0 ? void 0 : couponList[0]} amountColor={amountColor} toastConfig={toastConfig} updateCouponList={updateCouponList} index={0} location={location} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={(_b = formatCouponConfigRes === null || formatCouponConfigRes === void 0 ? void 0 : formatCouponConfigRes[(_a = couponList === null || couponList === void 0 ? void 0 : couponList[0]) === null || _a === void 0 ? void 0 : _a.campaignKey]) === null || _b === void 0 ? void 0 : _b.bizLine} hotelchannel={hotelchannel}/>
        </View>
      </Sensor>
      <View x-elseif={couponList.length === 2} className="magicmember-two-col" style={{
            paddingLeft: isShowContainer ? '12rpx' : 0
        }}>
        {couponList.map((couponData, index) => {
            var _a;
            return <Sensor key={index} once={true} onAppear={() => couponAppear(couponData)}>
            <TwoColCoupon location={location} isShowContainer={isShowContainer} currentTimeMillis={currentTimeMillis} couponData={couponData} amountColor={amountColor} toastConfig={toastConfig} updateCouponList={updateCouponList} index={index} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={(_a = formatCouponConfigRes === null || formatCouponConfigRes === void 0 ? void 0 : formatCouponConfigRes[couponData === null || couponData === void 0 ? void 0 : couponData.campaignKey]) === null || _a === void 0 ? void 0 : _a.bizLine} hotelchannel={hotelchannel}/>
          </Sensor>;
        })}
      </View>
      <View x-elseif={couponList.length === 3} className="magicmember-three-col">
        {couponList.map((couponData, index) => {
            var _a;
            return <Sensor key={index} once={true} onAppear={() => {
                    couponAppear(couponData);
                }}>
            <MoreColCoupon location={location} isShowContainer={isShowContainer} isSlider={false} currentTimeMillis={currentTimeMillis} couponData={couponData} amountColor={amountColor} toastConfig={toastConfig} updateCouponList={updateCouponList} index={index} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={(_a = formatCouponConfigRes === null || formatCouponConfigRes === void 0 ? void 0 : formatCouponConfigRes[couponData === null || couponData === void 0 ? void 0 : couponData.campaignKey]) === null || _a === void 0 ? void 0 : _a.bizLine} hotelchannel={hotelchannel}/>
          </Sensor>;
        })}
      </View>
      <View x-elseif={!enableHorizontalScroll && couponList.length > 3} className="magicmember-three-col">
        {couponList.map((couponData, index) => {
            var _a;
            return <Sensor key={index} once={true} onAppear={() => {
                    couponAppear(couponData);
                }}>
            <MoreColCoupon location={location} isShowContainer={isShowContainer} isSlider={true} currentTimeMillis={currentTimeMillis} couponData={couponData} amountColor={amountColor} toastConfig={toastConfig} updateCouponList={updateCouponList} index={index} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={(_a = formatCouponConfigRes === null || formatCouponConfigRes === void 0 ? void 0 : formatCouponConfigRes[couponData === null || couponData === void 0 ? void 0 : couponData.campaignKey]) === null || _a === void 0 ? void 0 : _a.bizLine} hotelchannel={hotelchannel}/>
          </Sensor>;
        })}
      </View>
      <ScrollView x-else horizontal={true} style={{
            height: '238rpx',
            width: isShowContainer ? '704rpx' : '750rpx'
        }} showsHorizontalScrollIndicator={false}>
        <View style={{
            marginRight: isShowContainer ? '12rpx' : '24rpx'
        }}></View>
        {couponList.map((couponData, index) => {
            var _a;
            return <Sensor key={index} once={true} onAppear={() => couponAppear(couponData)}>
            <MoreColCoupon location={location} isSlider={true} isShowContainer={isShowContainer} index={index} currentTimeMillis={currentTimeMillis} couponData={couponData} amountColor={amountColor} toastConfig={toastConfig} updateCouponList={updateCouponList} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={(_a = formatCouponConfigRes === null || formatCouponConfigRes === void 0 ? void 0 : formatCouponConfigRes[couponData === null || couponData === void 0 ? void 0 : couponData.campaignKey]) === null || _a === void 0 ? void 0 : _a.bizLine} hotelchannel={hotelchannel}/>
          </Sensor>;
        })}
        <View style={{
            marginRight: isShowContainer ? '12rpx' : '24rpx'
        }}></View>
      </ScrollView>
    </>;
};
export default memo(CouponList);
